export const ProductSizeData = [
    '2.0', '2.2', '2.4', '2.6', '2.8', '2.10', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', 'Free Size'
];